import React from 'react';
import ContentLoader from 'react-content-loader';

const LoaderDetails = () => {
  return (
    <ContentLoader
      speed={2}
      width={770}
      height={820}
      viewBox="0 0 770 820"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <>
        <rect x="30" y="20" rx="4" ry="4" width="700" height="45" />
        
        <rect x="30" y="90" rx="3" ry="3" width="120" height="35" />
        
        <rect x="30" y="140" rx="3" ry="3" width="700" height="47" />
        <rect x="30" y="210" rx="3" ry="3" width="700" height="47" />
        <rect x="30" y="280" rx="3" ry="3" width="700" height="47" />
        <rect x="30" y="340" rx="3" ry="3" width="700" height="47" />
        <rect x="30" y="410" rx="3" ry="3" width="700" height="47" />
        <rect x="30" y="470" rx="3" ry="3" width="700" height="47" />
        <rect x="30" y="540" rx="3" ry="3" width="700" height="47" />
        <rect x="30" y="610" rx="3" ry="3" width="700" height="47" />
        <rect x="30" y="680" rx="3" ry="3" width="700" height="47" />
        <rect x="30" y="750" rx="3" ry="3" width="700" height="47" />
        <rect x="30" y="810" rx="3" ry="3" width="700" height="47" />
      </>
    </ContentLoader>
  );
};


export default LoaderDetails;
